.ms-Persona--pointer {
  text-decoration: none;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer !important;

  .ms-Persona-title {
    display: inline-block;
    color: #000;
    text-decoration: underline;
    text-underline-offset: 4px;
  }

  &:hover {
    text-decoration: none;

    .ms-Persona-title {
      color: var(--sbb-color-red125);
    }
  }
}

.user-status-unknown {
  * {
    opacity: 0.6;
  }

  .ms-Persona-title,
  .ms-Persona-secondaryText {
    zoom: 1;
  }
}

.user-status-deleted {
  * {
    opacity: 0.6;
  }

  .ms-Persona-title,
  .ms-Persona-secondaryText {
    text-decoration: line-through;
  }
}
